import { environmentConfig } from "@src/appV2/environment";

/**
 * Image width for badge verification photos.
 */
export const BADGE_VERIFICATION_IMAGE_WIDTH = 1024;

/**
 * Minimum height for the page header spacer in badge verification screens
 * that don't use PageHeaderTopRow. Matches the height of PageHeaderTopRow
 * so dialog content stays vertically consistent across steps.
 */
export const PAGE_HEADER_SPACER_MIN_HEIGHT = 48;

/**
 * Maximum time (ms) to wait for the AI grade before falling through to
 * the confirm screen without a grade result.
 */
export const GRADE_FETCH_TIMEOUT_MS = 7_500;

/**
 * Base URL for contractor badge verification API endpoints.
 */
export const CONTRACTOR_BADGE_VERIFICATIONS_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/contractor-badge-verifications`;

/**
 * Badge verification flow types for analytics tracking.
 */
export const BADGE_VERIFICATION_FLOW = {
  UPLOAD: "upload",
  SKIP: "skip",
} as const;
